import { createPortal } from 'react-dom'

const Portal = props => {
	const { children, id } = props
	return createPortal(children, document.getElementById(id))
}

export default Portal
